jQuery('.selectable_varient_item').on('click',function(){
  	let id = jQuery(this).attr('data-id');
	jQuery(this).addClass('selected').siblings().removeClass('selected')
    jQuery('select[name=id]').val(id)
})

jQuery('.inlineaddtocartform').on('submit',function(e){
  
  	e.preventDefault();
  	var current = jQuery(this);
	var ID = jQuery(this).find('input[name="id"]').val(); 
 	
  	//current.find('.addtocartinline .cart-added').show()
    //current.find('.addtocartinline .cart-icon').hide();
    jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
      dataType: 'json', 
     success: function (data) {
       
	  jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        
          
         success: function (cartData) {
			let raw_data = cartData
			let d = JSON.parse(raw_data)
           
         	jQuery('.cart-Update').html(d.item_count)
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'))

         } 
       });
       
      
      setTimeout(function(){
        current.find('.addtocartinline .cart-icon').hide();
      	current.find('.addtocartinline .cart-added').show();
        current.find("button.addtocartinline ").attr("disabled", true);
      },100)
      


     } 
   });
});


jQuery('.inlineaddform').on('submit',function(e){
  
  	e.preventDefault();
  	var current = jQuery(this);
	var ID = jQuery(this).find('input[name="id"]').val(); 
 	
    jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
      dataType: 'json', 
     success: function (data) {
       
	  jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        
          
         success: function (cartData) {
			let raw_data = cartData
			let d = JSON.parse(raw_data)
           
         	jQuery('.cart-Update').html(d.item_count)
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'))

         } 
       });
 

     } 
   });
});


// FRO PROGRESS BAR AND DISCUNTON ADDING PRODUCT

document.addEventListener('ajaxProduct:added',async function(){
    let total_cart_items = await get_cart_data();   
  	resetProgress(total_cart_items);
  
    //alert(total_cart_items);
    
    jQuery('.cart-Update').text(total_cart_items);
  
})

document.addEventListener('drawerOpen',async function(){
    let total_cart_items = await get_cart_data();    
    resetProgress(total_cart_items)
})


document.addEventListener('cart:updated', async function(){
    let total_cart_items = await get_cart_data();    
    resetProgress(total_cart_items)
    
   jQuery('.cart-Update').text(total_cart_items);
 	
})


document.addEventListener('cart:open', async function(){
    let total_cart_items = await get_cart_data();    
    resetProgress(total_cart_items)
})

function resetProgress(total_cart_items){
    if(!total_cart_items){
      total_cart_items = 0;
    }
	let target = jQuery('.rewards-progress').attr('data-target');
	jQuery('.rewards-progress .pre-unlock .progress-bar span').width(0)	
    jQuery('.post-unlock .done').hide();
    jQuery('.post-unlock .pre').hide();
  
  
  // Only update dynamic .txt label if it exists (skips static FREE SHIPPING message)
  let addHTML = 'ADD '+ (target - total_cart_items) +' MORE AND SAVE '
  jQuery('.post-unlock .pre .txt').html(addHTML);
  	
    if(total_cart_items>=target){
      jQuery('.post-unlock .done').show();
      jQuery('.post-unlock .pre').hide();
    }else{
      jQuery('.post-unlock .done').hide();
      jQuery('.post-unlock .pre').show();
    }
   	
  	
    
    
    let steps = (100 / target).toFixed(2);
  	let width  = steps * total_cart_items;
    if(width > 100){
      width = 100
    }
  jQuery('.rewards-progress .pre-unlock .progress-bar span').css({ 'width': width+'%' })	
  
  
  
  
}



function get_cart_data(){
  
  return new Promise(function(resolve, reject) {
    
	jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        success: function (cartData) {
          let raw_data = cartData
          let d = JSON.parse(raw_data)
          resolve(d.item_count);
        } 
     });
    
  });
	
  		
	
}





  
jQuery('.slideNavText').on('click',function(){
	jQuery('.slideNavWrap').toggleClass('openIt');
	jQuery('body').addClass('overHid');
	jQuery('.overlayIt').addClass('show');
})
  
jQuery(".nav-close").click(function(){
  	jQuery(".slideNavWrap").removeClass("openIt");
	jQuery('body').removeClass('overHid');
	jQuery('.overlayIt').removeClass('show');
});

jQuery(".overlayIt").click(function(){
  	jQuery(".slideNavWrap").removeClass("openIt");
	jQuery('body').removeClass('overHid');
	jQuery('.overlayIt').removeClass('show');
});